<template>
  <div>
    <button type="button" class="btn btn-secondary" v-on:click="refreshCourseCache" id="tooltip-refresh-course-data-button">
      <span v-if="isCurrentCourseUpdating" class="fal fa-spinner fa-spin"></span><span v-else-if="courseRefreshed" class="far fa-check"></span>
        Refresh Course Data
    </button>
    <div v-if="course.cacheTimestamp" class="mt-1"><small class="form-text text-muted text-center"><i>Last Update: {{ new Date(course.cacheTimestamp).toLocaleString() }}</i></small></div>

    <b-tooltip target="tooltip-refresh-course-data-button" triggers="hover" placement="left" variant="info">
      <div class="text-left">
        Refreshing the data will update the course information and structure but will not include any unit updates made today. Unit updates will be visible tomorrow.<br/>
        This process will take approximately 5-10 minutes. Please wait until the process indicator completes before proceeding.
      </div>
    </b-tooltip>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['course'],
  data() {
    return {
      refreshingCourse: false,
      courseRefreshed: false,
    }
  },
  computed: {
    ...mapGetters({
      isCourseUpdating: 'courseUpdates/isCourseUpdating'
    }),
    isCurrentCourseUpdating() {
      return this.course && this.isCourseUpdating(this.course.code)
    },

  },
  methods: {
    ...mapActions({
      refreshCourse: 'courseUpdates/refreshCourse',
    }),
    refreshCourseCache() {
      this.refreshCourse({courseId: this.course.code, version: this.course.courseLoopVersionNumber})
      this.refreshingCourse = true
    },
  },
  watch: {
    isCurrentCourseUpdating: function (refreshing, prev) {
      if (prev && !refreshing) {
        console.log('Course refreshed:', this.course.code)
        this.refreshingCourse = false
        // Emit an event to update the course selection
        // Note: Currently unused, as the main course record is updated by the course-updates store on completion
        console.log('Emitting updateSelection for course:', this.course.id, this.course.courseLoopVersionNumber, !this.course.isActive)
        this.$emit('updateSelection', this.course.id, this.course.courseLoopVersionNumber, !this.course.isActive)
        this.courseRefreshed = true
      }
    },

  }
}
</script>

<style lang="scss" scoped>

</style>
